// Mock data for Esprit Ouest

// Mock data for Esprit Ouest

export const spaces = [
{
  id: 1,
  type: "Bureau Privé",
  title: "Bureaux",
  description: "Espace privatif lumineux de 14 \xE0 32m\xB2, id\xE9al pour 1 \xE0 4 personnes. Vide ou meubl\xE9 avec une possibilit\xE9 d'acc\xE8s \xE0 internet.",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/2r27clam_ChatGPT%20Image%204%20mai%202026%2C%2012_01_18.png",
  capacity: "1-4 personnes",
  surface: "15-30m²",
  price: "À partir de 400€/mois",
  gallery: [
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/2r27clam_ChatGPT%20Image%204%20mai%202026%2C%2012_01_18.png",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/4v0p12nt_ChatGPT%20Image%204%20mai%202026%2C%2012_01_09.png",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/aoweuat2_ChatGPT%20Image%204%20mai%202026%2C%2012_01_23.png",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/x8uzm7qm_ChatGPT%20Image%204%20mai%202026%2C%2012_01_37.png"]

},
{
  id: 2,
  type: "Salle de Réunion",
  title: "Salles de Réunions",
  description: "Salles de réunion modernes avec équipements audiovisuels professionnels. Location à l'heure ou à la journée.",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/gvcmpxg5_ChatGPT%20Image%205%20mai%202026%2C%2009_52_33.png",
  capacity: "Jusqu'\xE0 10 personnes",
  surface: "20-40m²",
  price: "\xC0 partir de 70\u20AC/heure",
  gallery: [
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/gvcmpxg5_ChatGPT%20Image%205%20mai%202026%2C%2009_52_33.png"]

},
{
  id: 3,
  type: "Séminaire",
  title: "Manoir",
  description: "Lieu d'exception en Normandie, \xE0 seulement 1 h 30 de Paris, pour vos s\xE9minaires et \xE9v\xE9nements professionnels dans un cadre unique et inspirant.",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/btpvsz3w_1.jpg",
  capacity: "Jusqu'\xE0 10 personnes",
  surface: "300-380m\xB2",
  price: "Sur devis",
  gallery: [
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/btpvsz3w_1.jpg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/is0t3av2_2.jpeg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/wfo97exu_3.png",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/26ltny7t_4.jpeg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/f15e4ggm_5.jpeg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/tb4pyzwx_6.jpg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/iqkb3vqn_7.jpeg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/i3wmpxaz_8.png",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/9mm6bqrs_9.png",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/8awm8ijj_10.jpeg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/7dlhf6om_11.jpg",
  "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/o0r1vyll_12.jpeg"]

}];


export const locations = [
{
  id: 1,
  name: "Esprit Ouest Versailles",
  address: "16 Boulevard de la Reine, 78000 Versailles\n98 Boulevard de la Reine, 78000 Versailles",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/r3pkkalm_Diapositive1.PNG",
  spaces: "19 bureaux priv\xE9s \u2022 1 salle de r\xE9union",
  status: "Ouvert"
},
{
  id: 2,
  name: "Esprit Ouest Jouy-en-Josas",
  address: "5-5bis Rue du Petit Robinson, 78350 Jouy-en-Josas",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/eataxeop_Pr%C3%A9sentation1.png",
  spaces: "9 bureaux priv\xE9s \n",
  status: "Ouvert"
},
{
  id: 3,
  name: "Esprit Ouest Viroflay",
  address: "7 Rue des Vignes, 78220 Viroflay",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/4p9xlt5g_Pr%C3%A9sentation1.jpg",
  imagePosition: "center 25%",
  spaces: "6 bureaux privés",
  status: "Ouvert"
},
{
  id: 4,
  name: "Manoir",
  address: "Le Neubourg, Normandie",
  image: "https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/lvlil929_Pr%C3%A9sentation2.jpg",
  spaces: "Séminaires • Événements • Réceptions",
  status: "Ouvert"
}];


export const advantages = [
{
  id: 1,
  title: "Flexibilité Totale",
  description: "Contrats mensuels sans engagement, adaptez votre espace selon vos besoins.",
  icon: "Zap"
},
{
  id: 2,
  title: "Confort Premium",
  description: "L\u2019\xE9l\xE9gance n\u2019est pas un luxe, c\u2019est un confort de travail. Nos espaces allient esth\xE9tisme et ergonomie.",
  icon: "Heart"
},
{
  id: 3,
  title: "Image Professionnelle",
  description: "Adresse prestigieuse et espaces élégants pour valoriser votre entreprise.",
  icon: "Award"
},
{
  id: 4,
  title: "Services Inclus",
  description: "Nos formules sont claires et sans artifices : tout est compris, loyer, charges, fiscalit\xE9, et rien n\u2019est impos\xE9. Les services compl\xE9mentaires sont optionnels pour avoir les prix les plus ajust\xE9s.",
  icon: "CheckCircle"
},
{
  id: 5,
  title: "Localisation Idéale",
  description: "Localisations centrales stratégiques, parfaitement connectées aux réseaux de transports en commun et disposant d'offres de stationnement à proximité immédiate.",
  icon: "MapPin"
},
{
  id: 6,
  title: "Communauté",
  description: "Travailler seul ne veut pas dire \xEAtre isol\xE9. Esprit Ouest favorise les interactions naturelles entre locataires. Des \xE9changes naissent des id\xE9es, parfois m\xEAme des projets communs.",
  icon: "Users"
}];


export const testimonials = [
{
  id: 1,
  name: "Sophie Durand",
  role: "CEO, StartTech Innovation",
  content: "Esprit Ouest a transformé notre façon de travailler. Les bureaux sont magnifiques et l'équipe aux petits soins. Un vrai coup de cœur !",
  rating: 5
},
{
  id: 2,
  name: "Marc Leblanc",
  role: "Architecte Indépendant",
  content: "La qualité des espaces et la localisation sont exactement ce que je recherchais. Ambiance professionnelle et inspirante à Versailles.",
  rating: 5
},
{
  id: 3,
  name: "Claire Martin",
  role: "Directrice Marketing",
  content: "Nos clients sont toujours impressionnés quand ils visitent nos bureaux. L'image professionnelle que ça nous donne est inestimable.",
  rating: 5
}];


export const faqs = [
{
  id: 1,
  question: "Quels sont les types de contrats proposés ?",
  answer: "Nous proposons des contrats mensuels ou journaliers flexibles sans engagement de durée, ainsi que des formules trimestrielles et annuelles avec tarifs préférentiels."
},
{
  id: 2,
  question: "Quels services sont inclus ?",
  answer: "Ménage hebdomadaire, charges (électricité, eau, chauffage, TF) et accès 24/7 pour les bureaux privés sont inclus. Internet haut débit et ameublement sont disponibles en option."
},
{
  id: 3,
  question: "Puis-je visiter avant de réserver ?",
  answer: "Absolument ! Nous vous invitons à visiter nos espaces sur rendez-vous. Nos équipes se feront un plaisir de vous faire découvrir les lieux et répondre à toutes vos questions."
},
{
  id: 4,
  question: "Comment réserver le Manoir pour un séminaire ?",
  answer: "Le Manoir se réserve sur devis personnalisé. Contactez-nous pour discuter de votre événement et recevoir une proposition adaptée à vos besoins."
}];